/* eslint-disable react/prop-types */
import Img from 'gatsby-image';
import { getFluidGatsbyImage } from 'gatsby-storyblok-image';
import React from 'react';

const FluidImage = (props) => {
  const { image, className } = props;

  if (!image) {
    return null;
  }

  // Get image file name
  const { filename } = image;

  if (filename == null || filename == '') {
    return null;
  }

  const fluidProps = getFluidGatsbyImage(image.filename, {
    maxWidth: props.maxWidth || 3120,
    quality: props.quality || 95,
    backgroundColor: '#B9B5AC',
  });

  if (fluidProps?.base64) {
    // set to undefined
    fluidProps.base64 = undefined;
  }

  if (fluidProps.srcSet == null) {
    // remove srcSet
    fluidProps.srcSet = fluidProps.src;
  }

  return (
    <Img
      fluid={fluidProps}
      draggable={false}
      alt={image.alt}
      className={className}
      backgroundColor="#B9B5AC"
      loading={props.critical ? `eager` : `lazy`}
      fadeIn
    />
  );
};

export default FluidImage;
